// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { SystemsIntegrationsSubscriptions } from '../../../../types/server/modules/systemsIntegrations/subscriptions';

export type * from '../../../../types/server/modules/systemsIntegrations/subscriptions';

export const createSubscriptions = ( requests: Requests ): SystemsIntegrationsSubscriptions => ({
  ExternalSystemsIntegrations: ( params, onChange ) => {
          return requests.subscribe( `/external-systems-integrations/:id?`, params, 'ExternalSystemsIntegrations', onChange );
          },
  SystemsIntegrationsErpSyncMirror: ( params, onChange ) => {
          return requests.subscribe( `/systems-integrations/erp-sync-mirror/:id?`, params, 'SystemsIntegrationsErpSyncMirror', onChange );
          },
  SystemsIntegrationsErpDriftEpisodes: ( params, onChange ) => {
          return requests.subscribe( `/systems-integrations/erp-drift-episodes/:id?`, params, 'SystemsIntegrationsErpDriftEpisodes', onChange );
          },
  SystemsIntegrationsAccountEmails: ( params, onChange ) => {
          return requests.subscribe( `/systems-integrations/account-emails/:id?`, params, 'SystemsIntegrationsAccountEmails', onChange );
          },
  SystemsIntegrationsChannelCategories: ( params, onChange ) => {
          return requests.subscribe( `/systems-integrations/channel-categories/:integrationId?`, params, 'SystemsIntegrationsChannelCategories', onChange );
          }
});
